import axios from "axios";
import { navigate } from "gatsby";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useAuthContext } from "../../contexts/AuthProvider";
import Loading from "../Loading";

function AdminPrivateRoute({ children }) {
	const { user, setUser } = useAuthContext();
	const [authenticated, setAuthenticated] = useState(false);
	const [loading, setLoading] = useState(true);

	// useEffect(() => {
	// 	// Set up axios interceptors once
	// 	const unauthorizedInterceptor = axios.interceptors.response.use(
	// 		undefined,
	// 		(err) => {
	// 			if (err.response && err.response.status === 401) {
	// 				Swal.fire("Not authorized !", err.response.data.message, "warning");
	// 				navigate("/");
	// 			}
	// 			return Promise.reject(err);
	// 		},
	// 	);

	// 	const errorInterceptor = axios.interceptors.response.use(
	// 		(response) => response,
	// 		(error) => {
	// 			if (error.response && error.response.status === 403) {
	// 				Swal.fire("Interdite !", error.response.data.message, "warning");
	// 				navigate("/403");
	// 			} else if (error.response && error.response.status === 404) {
	// 				// Only treat non-API 404s as page-not-found; allow API 404s
	// 				// to be handled by the calling component (e.g. certificate not found).
	// 				const url = error.config?.url || "";
	// 				const isApiRequest =
	// 					url.startsWith("/api/") || url.includes("/api/");

	// 				if (!isApiRequest) {
	// 					Swal.fire("404 Error", "URL/Page not found", "warning");
	// 					navigate("/404");
	// 				}
	// 			}
	// 			return Promise.reject(error);
	// 		},
	// 	);

	// 	return () => {
	// 		axios.interceptors.response.eject(unauthorizedInterceptor);
	// 		axios.interceptors.response.eject(errorInterceptor);
	// 	};
	// }, []);

	useEffect(() => {
		// Only fetch user status if we don't already have a user
		if (!user) {
			axios
				.get("/api/checkLoggedIn")
				.then((res) => {
					setUser(res.data.user);
					setAuthenticated(true);
				})
				.catch(() => {
					setAuthenticated(false);
				})
				.finally(() => {
					setLoading(false);
				});
		} else {
			// If user is already known, no need to re-check
			setAuthenticated(true);
			setLoading(false);
		}
	}, [user, setUser]);

	useEffect(() => {
		if (!loading && !authenticated) {
			navigate("/login");
		}
	}, [loading, authenticated]);

	if (loading || !authenticated) {
		return <Loading position="relative" height="h-[calc(100vh-64px)]" />;
	}

	return <>{children}</>;
}

export default AdminPrivateRoute;
